module.exports = __webpack_public_path__ + "static/bg (4)-3c8bccdcabc61e4b472c78f44bdce746.jpg";